import router from './router'

export default {
	moduleName: 'image',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/image/index.js